export default "/_next/static/assets/images/sprite.35f9ac6d88bca5265cffddd385f45bbf.svg";